import { DRResponseMeta } from '@app/shared/models/response';

export interface WhoAndWhen {
    whoAndWhen: string;
}

export abstract class BaseModel {

    public be_smp_warning?: DRResponseMeta;

    protected constructor(json?: any) {
        this.initialize(json);
    }

    public initialize(json: any): void {
        const mappings = this.setObjectMappings(json);
        Object.assign(this, json, mappings);
    }

    protected setObjectMappings(json: any): any {
        return {};
    }
}

export interface HasId {
    id: string;
}

export abstract class BaseWithId extends BaseModel implements HasId {
    public id: string;

    protected constructor(json?: any) {
        super(json);
    }
}
